import {Branding} from '../Branding.types'

import LogoHM from './icons/Logo-HM-Compact-Negative.svg'

export const localhost: Branding = {
  nationalBrandName: 'Heidelberg Materials',
  nationalLogoUrl: LogoHM,
  nationalUrl: 'https://www.heidelbergmaterials.com',
  nationalLogoTitle: 'Heidelberg Materials',

  contactEmail: 'hub.zement@heidelbergmaterials.com',
  contactEmailSubject: 'Mail from Hub Portal',
  pageTitle: 'Heidelberg Materials',

  safetyDataSheetLink: 'https://www.heidelbergcement.de/de/sdb',
  epdsLink: 'https://www.heidelbergmaterials.us/home/sustainability/epds',
  productDataSheetsLink: 'https://www.heidelbergmaterials.us/products/cement#product-data-sheets',

  country: 'DE'
}
